import { Component, ViewChild, ElementRef, AfterViewInit, OnDestroy, OnInit, TemplateRef, NgZone, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BrowserMultiFormatReader, DecodeHintType, BarcodeFormat } from '@zxing/library';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { delay, Subject, Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { currency, dobData, dobMask, SharedService } from 'src/app/services/shared.service';
import { SocketsService } from 'src/app/services/socket.service';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { SSN_mask } from 'src/app/shared/regex';
import { environment } from 'src/environments/environment';
import { extra_data } from '../../components/finance/finance-customer/custom-plan-modal/custom-plan-modal.component';
import { NgClass } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
    selector: 'app-scanner',
    templateUrl: './scanner.component.html',
    styleUrls: ['./scanner.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, FormsModule, ReactiveFormsModule, NgxMaskDirective]
})
export class ScannerComponent implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild('videoElement', { static: false }) videoElement!: ElementRef<HTMLVideoElement>;
  @ViewChild('confirmation', { static: false }) confirmation!: TemplateRef<void>;
  @ViewChild('confirmation1', { static: false }) confirmation1!: TemplateRef<void>;

  public hints = new Map().set(DecodeHintType.POSSIBLE_FORMATS, [
    BarcodeFormat.QR_CODE,
    BarcodeFormat.PDF_417,
    BarcodeFormat.CODE_128,
  ]);
  barcodeReader = new BrowserMultiFormatReader(this.hints);
  detectedBarcode: string | null = null;
  imageCaptured: string | null = null;
  intervalId: any;
  scanning = true;
  formats: BarcodeFormat[] = [BarcodeFormat.PDF_417];
  extra_data!: any;
  public previewForm!: UntypedFormGroup;
  public showPreview:boolean=false;
  public dobData!:dobData;
  public dobSubscription: Subject<any> = new Subject();
  public showDobError:boolean=false;
  public country_data:any;
  public enableZip = false;
  public SSNmask = SSN_mask;
  public countrySub!:Subscription;
  public dateOfBirthMask!: dobMask;
  public mask = '';
  public currency_data!: currency;
  public hideCommonLoader: boolean = false;
  public showDone: boolean = false;
  public token:string=''
  public display_logo:string='';
  public videoStream: MediaStream | null = null;
  public disconect:boolean=false;
  confirmationModal!: BsModalRef;
  confirmationModal1!: BsModalRef;
  public errorForInvalid:boolean=false;
  public iosFrameRequestId: number[] = [];
  private iosTimeoutId: any = null;
  public iosTimeoutIdArr: any[] = [];
  ssnControl !:any;


  constructor(private _shared: SharedService,private fb: UntypedFormBuilder,private _api: ApiService, private route:ActivatedRoute,
    private _socket:SocketsService, private modalService: BsModalService, public loader:LoaderService,private zone: NgZone
  ) {
    this.token=this.route.snapshot.params['token'];
    this.display_logo=this.route.snapshot.queryParams['currency'];
    console.log(this.display_logo,this.token)
    this.previewForm = this.fb.group({
      first_name: ['',[]],
      last_name: [''],
      address: [''],
      address_line_2: [''],
      zip: [''],
      city: [''],
      state: [''],
      dob:[''],
      monthly_income: ['', [Validators.required, Validators.pattern('^\\d{1,10}(\\.\\d{1,2})?$'), Validators.maxLength(10)]],
      social_security_number: ['', [Validators.required]],
      state_code: ['']
    });

    this.ssnControl = this.previewForm.get('social_security_number');
    if (environment.environment === 'LIVE') {
      this.previewForm?.addValidators(ssnValidator());
    }

    this.ssnControl?.updateValueAndValidity();
  }
  ngOnInit() {
    this._socket.emit(this._shared.socketIds.DL_LOADER, { token: this.token, loader: true })
    this._socket.on(this._shared.socketIds.DL_DATA_CANCEL, (data: any) => {
      this.disconect = true;
      this.stopScanner()
      this.confirmationModal?.hide();
    })
    this._socket.on('CONNECTED_USERS' , (data :any)=>{
      console.log("the data is",data)
      this.extra_data = data
    })
    // document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  // handleVisibilityChange = () => {
  //   if (document.visibilityState === 'visible') {
  //     // console.log('[App] Tab visible, reconnecting socket if needed');
  //     // alert('Tab is now visible');
  //     this._socket.connect();

  //   }
  // };
  // decodeBarcodeFromImage(imagePath: string) {
  //   const img = new Image();
  //   img.src = imagePath;

  //   img.onload = () => {
  //     console.log('Image Dimensions:', img.width, img.height);
  //     this.barcodeReader.decodeFromImage(img).then(result => {
  //       alert(`✅ Decoded Barcode: ${result.getText()}`);
  //     }).catch(err => {
  //       console.log('❌ Error decoding barcode:', err.name, err.message);
  //     });
  //   };

  //   img.onerror = () => {
  //     console.log('❌ Failed to load image:', imagePath);
  //   };
  // }



  // Call api after submit of ssn and income
  async sumbitScanData() {
    if (this.previewForm.invalid) {
      this.previewForm.markAsDirty();
      this.previewForm.markAllAsTouched();
      return;
    }

    if (!this.previewForm.value.monthly_income || (this.previewForm.value.monthly_income && Number(this.previewForm.value.monthly_income) <= 0)) {
      this._shared.customPopups('Please enter valid monthly income', 1);
      return;
    }
    // if (this._shared.ssncustomValidator(this.previewForm.value.social_security_number) && environment.environment !== 'DEMO') {
    //   this._shared.customPopups('Please enter valid SSN', 1);
    //   return;
    // }
    if (!this.token && environment.environment !== 'DEMO') {
      this._shared.customPopups('Token is required', 1);
      return;
    }
    const data: any = { json: this.previewForm.value };
    data.token = this.token;
    data.extra_data = this.extra_data;
    this._api.api(data, 'dl_scan/route_dl_data').subscribe((response: any) => {
      if (response && !response.is_error) {
        this.showDone = true;
        this._socket.emit(this._shared.socketIds.DL_LOADER, { token: this.token, loader: false })
        if (data.extra_data?.isWebConnect && data.extra_data?.isMobile){
         window.close();
        }
      } else {
        if (data.extra_data?.isWebConnect && data.extra_data?.isMobile){
           window.close();
        }
      }
    });
  }

  ngAfterViewInit() {
    this.startScannerAccDevice();
  }

  startScannerAccDevice(){
    const userAgent = navigator.userAgent;
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      this.hints.set(DecodeHintType.TRY_HARDER, true);
      this.barcodeReader = new BrowserMultiFormatReader(this.hints);
      this.startScannerForIOS();
    }else{
      this.startScannerForAndroid();
    }
  }

  startScannerForAndroid() {

    if (!this.videoElement || !this.videoElement.nativeElement) {
      alert('❌ Video element is not initialized.');
      return;
    }

    this.scanning = true;
    const video = this.videoElement.nativeElement;

    navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment', width: { ideal: 1280 }, height: { ideal: 720 }} })
      .then((stream) => {
        this.videoStream=stream;
        video.srcObject = stream;
        video.play();

        // Start scanning and set a timer to stop after 20 seconds
        // const stopAfterSeconds = 30; // Set timeout duration
        // const timeoutId = setTimeout(() => {
        //   this.stopScanner(); // Stop scanning after 20 seconds
        //   alert('⏳ Time is up! Scanner stopped.');
        // }, stopAfterSeconds * 1000); // Convert to milliseconds

        // alert(video);

        this.barcodeReader.decodeFromVideoDevice(null, video, (result, err) => {
          this.hideCommonLoader=true;
          if (result) {
            const barcodeFormat = result.getBarcodeFormat();
            if (barcodeFormat === BarcodeFormat.PDF_417) {
              this.detectedBarcode = result.getText();
              const parsedData = this._shared.parseAllAAMVAKeys(this.detectedBarcode);
              this.previewForm.patchValue({
                first_name:parsedData["Middle Name"] && parsedData["Middle Name"] !== 'NONE' && parsedData["Middle Name"] !== 'NULL' &&  parsedData["Middle Name"] !== 'null'? ((parsedData["First Name"]||parsedData["Customer Given Name"])+' '+parsedData["Middle Name"]):(parsedData["First Name"]||parsedData["Customer Given Name"]||''),
                last_name: ( parsedData["Last Name"] !== 'NONE' && parsedData["Last Name"] !== 'NULL' &&  parsedData["Last Name"] !== 'null')? parsedData["Last Name"]||parsedData["Customer Family Name"]||'':'',
                address:( parsedData["Street Address"] !== 'NONE' && parsedData["Street Address"] !== 'NULL' &&  parsedData["Street Address"] !== 'null')? (parsedData["Street Address"]||''):'',
                address_line_2: ( parsedData["Street Address Line 2"] !== 'NONE' && parsedData["Street Address Line 2"] !== 'NULL' &&  parsedData["Street Address Line 2"] !== 'null')? (parsedData["Street Address Line 2"]||''):'',
                zip: ( parsedData["Postal Code"] !== 'NONE' && parsedData["Postal Code"] !== 'NULL' &&  parsedData["Postal Code"] !== 'null')? (parsedData["Postal Code"]||''):'',
                city: ( parsedData["City"] !== 'NONE' && parsedData["City"] !== 'NULL' &&  parsedData["City"] !== 'null')? (parsedData["City"]||''):'',
                state: ( parsedData["State"] !== 'NONE' && parsedData["State"] !== 'NULL' &&  parsedData["State"] !== 'null')? (parsedData["State"]||''):'',
                social_security_number: ( parsedData["Social Security Number"] !== 'NONE' && parsedData["Social Security Number"] !== 'NULL' &&  parsedData["Social Security Number"] !== 'null')? (parsedData["Social Security Number"]||''):'',
                dob:( parsedData["Date of Birth (MMDDYYYY)"] !== 'NONE' && parsedData["Date of Birth (MMDDYYYY)"] !== 'NULL' &&  parsedData["Date of Birth (MMDDYYYY)"] !== 'null')? (parsedData["Date of Birth (MMDDYYYY)"]||''):'',
              });
              if( this.previewForm.controls['first_name'].value || this.previewForm.controls['last_name'].value || this.previewForm.controls['dob'].value){
                this.showPreview=true;
                this.stopScanner();
              }else{
                this.confirmationModal?.hide();
                this.confirmationModal1?.hide();
                // this.errorForInvalid=true;
                this.openModal1(this.confirmation1);
                this.stopScanner();
              }
            }
          }
          if (err) {
            // alert(`Decoding error: ${err.name}, ${err.message}`);
          }

          this.hideCommonLoader=false;
        });
      })

      .catch(err => console.error('❌ Camera error:', err));
  }

  // captureImage(video: HTMLVideoElement) {
  //   const canvas = document.createElement('canvas');
  //   const context = canvas.getContext('2d');

  //   if (!context) {
  //     console.error('❌ Canvas context not found.');
  //     return;
  //   }

  //   canvas.width = video.videoWidth;
  //   canvas.height = video.videoHeight;
  //   context.drawImage(video, 0, 0, canvas.width, canvas.height);

  //   this.imageCaptured = canvas.toDataURL('image/png');
  //   // alert(`✅ Image Captured!`);

  //   // Send Image to API
  //   // this.uploadImage();
  // }

  // async uploadImage() {
  //   if (!this.imageCaptured) return;

  //   try {
  //     const blob = await fetch(this.imageCaptured).then(res => res.blob());
  //     const formData = new FormData();
  //     formData.append('file', blob, 'barcode-image.png');

  //     alert('📤 Sending image...');
  //     const response = await fetch('YOUR_API_URL', {
  //       method: 'POST',
  //       body: formData
  //     });

  //     if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

  //     const result = await response.json();
  //     console.log('✅ API Response:', result);
  //   } catch (error) {
  //     console.error('❌ Upload failed:', error);
  //   }
  // }


  startScannerForIOS() {
    if (!this.videoElement || !this.videoElement.nativeElement) {
      alert('❌ Video element is not initialized.');
      return;
    }

    this.scanning = true;
    const video = this.videoElement.nativeElement;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment', width: { ideal: 1920 }, height: { ideal: 1080 } } })
      .then((stream) => {
        this.videoStream = stream;
        video.srcObject = stream;
        video.play();

        this.iosTimeoutId = setTimeout(() => {
          const processFrame = async () => {

            if (!this.scanning) return;

            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            ctx?.drawImage(video, 0, 0, canvas.width, canvas.height);

            let imageData: any = ctx?.getImageData(0, 0, canvas.width, canvas.height);
            let data: any = imageData?.data;

            // Grayscale conversion
            for (let i = 0; i < data.length; i += 4) {
              const avg = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
              data[i] = data[i + 1] = data[i + 2] = avg;
            }

            // Contrast enhancement
            const contrast = 1.5; // Adjust as needed
            const intercept = 128 * (1 - contrast);
            for (let i = 0; i < data.length; i += 4) {
              data[i] = data[i] * contrast + intercept;
              data[i + 1] = data[i + 1] * contrast + intercept;
              data[i + 2] = data[i + 2] * contrast + intercept;
            }

            ctx?.putImageData(imageData, 0, 0);
            // Convert canvas to image and decode
            canvas.toBlob((blob: any) => {
              const reader = new FileReader();
              reader.onload = () => {
                const img = new Image();
                img.onload = async () => {
                  if (!this.scanning) return;
                  // Use your barcode reader's decode method here
                  let result= await this.barcodeReader.decode(img);
                  if (result) {
                    const barcodeFormat = result.getBarcodeFormat();
                    if (barcodeFormat === BarcodeFormat.PDF_417) {
                      this.scanning=false;
                      this.detectedBarcode = result.getText();
                      const parsedData = this._shared.parseAllAAMVAKeys(this.detectedBarcode || '');
                      //alert(JSON.stringify(parsedData));
                      this.previewForm.patchValue({
                        // first_name:parsedData["Middle Name"]?((parsedData["First Name"]||parsedData["Customer Given Name"])+' '+parsedData["Middle Name"]):(parsedData["First Name"]||parsedData["Customer Given Name"]||''),
                        // last_name: parsedData["Last Name"]||parsedData["Customer Family Name"]||'',
                        // address: parsedData["Street Address"]||'',
                        // address_line_2: parsedData["Street Address Line 2"]||'',
                        // zip: parsedData["Postal Code"]||'' ,
                        // city: parsedData["City"]||'' ,
                        // state: parsedData["State"]||'',
                        // social_security_number: parsedData["Social Security Number"]||'',
                        // dob:parsedData["Date of Birth (MMDDYYYY)"]||''

                        first_name:parsedData["Middle Name"] && parsedData["Middle Name"] !== 'NONE' && parsedData["Middle Name"] !== 'NULL' &&  parsedData["Middle Name"] !== 'null'? ((parsedData["First Name"]||parsedData["Customer Given Name"])+' '+parsedData["Middle Name"]):(parsedData["First Name"]||parsedData["Customer Given Name"]||''),
                        last_name: ( parsedData["Last Name"] !== 'NONE' && parsedData["Last Name"] !== 'NULL' &&  parsedData["Last Name"] !== 'null')? parsedData["Last Name"]||parsedData["Customer Family Name"]||'':'',
                        address:( parsedData["Street Address"] !== 'NONE' && parsedData["Street Address"] !== 'NULL' &&  parsedData["Street Address"] !== 'null')? (parsedData["Street Address"]||''):'',
                        address_line_2: ( parsedData["Street Address Line 2"] !== 'NONE' && parsedData["Street Address Line 2"] !== 'NULL' &&  parsedData["Street Address Line 2"] !== 'null')? (parsedData["Street Address Line 2"]||''):'',
                        zip: ( parsedData["Postal Code"] !== 'NONE' && parsedData["Postal Code"] !== 'NULL' &&  parsedData["Postal Code"] !== 'null')? (parsedData["Postal Code"]||''):'',
                        city: ( parsedData["City"] !== 'NONE' && parsedData["City"] !== 'NULL' &&  parsedData["City"] !== 'null')? (parsedData["City"]||''):'',
                        state: ( parsedData["State"] !== 'NONE' && parsedData["State"] !== 'NULL' &&  parsedData["State"] !== 'null')? (parsedData["State"]||''):'',
                        social_security_number: ( parsedData["Social Security Number"] !== 'NONE' && parsedData["Social Security Number"] !== 'NULL' &&  parsedData["Social Security Number"] !== 'null')? (parsedData["Social Security Number"]||''):'',
                        dob:( parsedData["Date of Birth (MMDDYYYY)"] !== 'NONE' && parsedData["Date of Birth (MMDDYYYY)"] !== 'NULL' &&  parsedData["Date of Birth (MMDDYYYY)"] !== 'null')? (parsedData["Date of Birth (MMDDYYYY)"]||''):'',

                      });
                      if( this.previewForm.controls['first_name'].value || this.previewForm.controls['last_name'].value || this.previewForm.controls['dob'].value){
                        this.zone.run(() => {
                          this.showPreview=true;
                        });

                        this.stopScanner();
                        // return;
                        //  clearTimeout(timeout);
                      }else{
                        this.confirmationModal1?.hide();
                        this.confirmationModal?.hide();
                        this.openModal1(this.confirmation1);
                        this.stopScanner();
                        return;
                      }
                    }
                  }
                  // alert(data)
                };
                img.src = reader.result as string;
                // this.src= reader.result as string; // Store the image data for later use
              };
              reader.readAsDataURL(blob);
            });
            //  if (this.scanning) {
            //     setTimeout(()=>{
            //       this.iosFrameRequestId.push(requestAnimationFrame(processFrame));
            //     },500);
            //   }
            if (this.scanning) {
              this.iosFrameRequestId.push(requestAnimationFrame(processFrame));
            }
          };
          this.iosFrameRequestId.push(requestAnimationFrame(processFrame));
        },2000);
        this.iosTimeoutIdArr.push(this.iosTimeoutId);

      })

      .catch(err => console.error('❌ Camera error:', err));
  }


  stopScanner() {
    // alert(this.count +'   '+ this.iosFrameRequestId.length)
    this.scanning = false;
    if (this.iosFrameRequestId) {
      this.iosFrameRequestId.forEach(id => cancelAnimationFrame(id));
      this.iosFrameRequestId = [];
    }
    if (this.iosTimeoutIdArr) {
      this.iosTimeoutIdArr.forEach(id => clearTimeout(id));
      this.iosTimeoutIdArr = [];
    }
    if (this.videoStream) {
      const tracks = this.videoStream.getTracks();
      tracks.forEach(track => track.stop());  // Stop each track (camera)
      const videoElement: HTMLVideoElement = <HTMLVideoElement>document.getElementById('videoElement');
      videoElement.srcObject = null;  // Disconnect the stream from the video element
      this.videoStream = null;

      console.log('Video stream stopped');

    }
  }

  ngOnDestroy() {
    this.stopScanner();
    this._socket.emit(this._shared.socketIds.DL_LOADER, { token: this.token, loader: false })
    // document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    this._socket.disconnect();
  }



  closeScannig() {
    this.zone.run(() => {
      this.disconect = true;
    });
    this.confirmationModal1?.hide();
    this.scanning = false;
    this._socket.emit(this._shared.socketIds.DL_LOADER, { token: this.token, loader: false })
    if (this.extra_data?.isWebConnect && this.extra_data?.isMobile) {
      window.close();
    }
    this.stopScanner();
  }

  openModal(template: TemplateRef<void>) {
    this.confirmationModal = this.modalService.show(template);
  }

  openModal1(template: TemplateRef<void>) {
    this.confirmationModal1 = this.modalService.show(template);
  }

  closeConfirmationModal() {
    this.confirmationModal?.hide();
    this.confirmationModal1?.hide();

    // if (this.errorForInvalid) {
    //   close = !close
    // }  
    // if (close) {

    this.scanning = false;
    this.disconect = true;
    this._socket.emit(this._shared.socketIds.DL_LOADER, { token: this.token, loader: false })
    this.stopScanner()
    // }
    // let interval = setTimeout(() => {
    //   // this.errorForInvalid = false;
    //   clearTimeout(interval);
    // }, 500)

  }

  closeInvalidConfirm() {
    this.confirmationModal?.hide();
    this.confirmationModal1?.hide();
    setTimeout(() => {
      // this.errorForInvalid = false;
      this.startScannerAccDevice();
      // clearTimeout(interval);
    }, 500)
  }

  formatMonthlyIncome(form: UntypedFormGroup, key: string) {
    const value = form.get(key)?.value;
    if (!isNaN(value)) {
      const formatted = parseFloat(value)?.toFixed(2);
      form.get(key)?.setValue(formatted, { emitEvent: false });
    }
  }

}

export const  ssnValidator = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return { ssnInvalid: true };
      }

      // Normalize input (remove dashes & spaces)
      const cleaned = control?.value?.social_security_number?.replace(/-/g, '').trim();

      // Must be exactly 9 digits
      if (!/^\d{9}$/.test(cleaned)) {
        return { ssnInvalid: true };
      }

      const invalidSSNs = [
        "002281852", "042103580", "062360749", "078051120", "095073645",
        "128036045", "135016629", "141186941", "165167999", "165187999",
        "165207999", "212099999", "165227999", "306302348", "165247999",
        "189092294", "308125070", "212097694", "549241889", "468288779",
        "123456789", "012345678"
      ];

      if (
        cleaned.slice(5, 9) === '0000' ||       // serial number
        cleaned.slice(3, 5) === '00' ||         // group number
        cleaned.slice(0, 3) === '000' ||        // area number
        cleaned.slice(0, 3) === '666' ||
        /^(.)\1+$/.test(cleaned) ||             // all same digits
        invalidSSNs.includes(cleaned) ||
        (parseInt(cleaned, 10) >= 987654320 &&
          parseInt(cleaned, 10) <= 987654329)
      ) {
        return { ssnInvalid: true };
      }

      return null; 
    };
};